// Image timeline effects — shared model. The SAME math drives the live preview
// (VideoPlayer canvas) and the server export (timeline_compositor FFmpeg filters),
// so what you see is what you get. Entrance effects use `duration` seconds from the
// clip start; fade/blur-out use `duration` seconds before the clip end.

export const IMAGE_EFFECTS = [
  { v: "none", l: "None" },
  { v: "fadein", l: "Fade In" },
  { v: "fadeout", l: "Fade Out" },
  { v: "zoomin", l: "Zoom In" },
  { v: "zoomout", l: "Zoom Out" },
  { v: "slideleft", l: "Slide In Left" },
  { v: "slideright", l: "Slide In Right" },
  { v: "slidetop", l: "Slide In Top" },
  { v: "slidebottom", l: "Slide In Bottom" },
  { v: "kenburns", l: "Ken Burns (Pan & Zoom)" },
  { v: "blurin", l: "Blur In (preview)" },
  { v: "blurout", l: "Blur Out (preview)" },
];
// Effects with full export parity (rendered identically in the exported video).
export const EXPORT_PARITY = new Set(["none", "fadein", "fadeout", "zoomin", "zoomout", "slideleft", "slideright", "slidetop", "slidebottom", "kenburns"]);

const clamp01 = (x) => Math.max(0, Math.min(1, x));

// Returns { alpha, scale, dx, dy, blur } where dx/dy are fractions of canvas W/H.
export function computeImageEffect(o, t) {
  const fx = { alpha: 1, scale: 1, dx: 0, dy: 0, blur: 0 };
  const type = o?.effect?.type || o?.effect || "none";
  if (!type || type === "none") return fx;
  const start = o.start || 0, end = o.end != null ? o.end : start + 5;
  const dur = Math.max(0.15, Math.min(o?.effect?.duration || 0.7, Math.max(0.15, (end - start) / 2)));
  const intensity = o?.effect?.intensity != null ? o.effect.intensity : 1;
  const pIn = clamp01((t - start) / dur);           // entrance progress 0..1
  const pOut = clamp01((end - t) / dur);            // exit progress 0..1
  const pAll = clamp01((t - start) / Math.max(0.15, end - start)); // whole-clip 0..1
  const ease = (p) => 1 - Math.pow(1 - p, 3);       // easeOutCubic

  switch (type) {
    case "fadein": fx.alpha = ease(pIn); break;
    case "fadeout": fx.alpha = ease(pOut); break;
    case "zoomin": fx.scale = 1 + 0.18 * intensity * (1 - ease(pIn)); break;   // starts big, settles
    case "zoomout": fx.scale = 1 + 0.18 * intensity * ease(pIn); break;
    case "slideleft": fx.dx = -(1 - ease(pIn)) * 0.6 * intensity; break;
    case "slideright": fx.dx = (1 - ease(pIn)) * 0.6 * intensity; break;
    case "slidetop": fx.dy = -(1 - ease(pIn)) * 0.6 * intensity; break;
    case "slidebottom": fx.dy = (1 - ease(pIn)) * 0.6 * intensity; break;
    case "kenburns": fx.scale = 1 + 0.12 * intensity * pAll; fx.dx = 0.05 * intensity * (pAll - 0.5); break;
    case "blurin": fx.blur = 14 * intensity * (1 - ease(pIn)); break;
    case "blurout": fx.blur = 14 * intensity * (1 - ease(pOut)); break;
    default: break;
  }
  return fx;
}
